<div class="card-body">
  <div class="card-content w-100">
    <h6 class="card-title">{{this.title}}</h6>
    <div class="h3">{{this.kpiData}}</div>
  </div>
</div>